"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _validators = _interopRequireDefault(require("./validators"));

var _messages = _interopRequireDefault(require("./messages"));

var _utils = require("./utils");

var _excluded = ["message"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var Validozer = /*#__PURE__*/function () {
  function Validozer() {
    _classCallCheck(this, Validozer);

    _defineProperty(this, "data", {});

    _defineProperty(this, "rules", {});

    _defineProperty(this, "messages", []);
  }

  _createClass(Validozer, [{
    key: "fails",
    value: function fails() {
      var _this = this;

      var isFail = false;
      this.messages = Object.keys(this.rules).map(function (name) {
        var _this$rules$name = _this.rules[name],
            rules = _this$rules$name.rules,
            label = _this$rules$name.label;
        var validate = Validozer.validate(_this.data[name], rules, label || name, _this.data);

        if (validate.isInvalid && !isFail) {
          isFail = true;
        }

        return [name, validate.message];
      }).filter(function (_ref) {
        var _ref2 = _slicedToArray(_ref, 2),
            message = _ref2[1];

        return !!message;
      });
      return isFail;
    }
  }, {
    key: "errors",
    value: function errors() {
      return new Map(this.messages);
    }
  }, {
    key: "errorsJSON",
    value: function errorsJSON() {
      return this.messages.map(function (_ref3) {
        var _ref4 = _slicedToArray(_ref3, 2),
            field = _ref4[0],
            message = _ref4[1];

        return {
          field: field,
          message: message
        };
      });
    }
  }], [{
    key: "rulesExtend",
    value: function rulesExtend(extension) {
      if (!_utils.is.obj(extension)) {
        throw new Error("Invalid rule extention");
      }

      Object.keys(extension).forEach(function (extname) {
        var _extension$extname = extension[extname],
            message = _extension$extname.message,
            validator = _objectWithoutProperties(_extension$extname, _excluded);

        if (!_utils.is.fnc(validator.exe)) {
          throw new Error("Invalid rule extention method `exe` is missing in rule `".concat(extname, "`"));
        }

        Object.assign(_messages["default"], _defineProperty({}, extname, message));
        Object.assign(_validators["default"], _defineProperty({}, extname, validator));
      });
    }
  }, {
    key: "rulesUpdateMessage",
    value: function rulesUpdateMessage(name, message) {
      if (!_validators["default"][name]) {
        throw new Error("\"".concat(name, "\" is not part of Validozer rules"));
      }

      _messages["default"][name] = _utils.is.obj(message) && ['min', 'max'].includes(name) ? _objectSpread(_objectSpread({}, _messages["default"][name]), message) : message;
    }
  }, {
    key: "validate",
    value: function validate(received, rules, attribute, data) {
      var array_rules = rules.split('|');
      var catch_name;
      var catch_param;
      var catch_value;
      var isInvalid = array_rules.some(function (validation) {
        var _validation$split = validation.split(/:|=/),
            _validation$split2 = _slicedToArray(_validation$split, 3),
            name = _validation$split2[0],
            param = _validation$split2[1],
            value = _validation$split2[2];

        catch_name = name;
        catch_param = param;
        catch_value = value;
        if (!_validators["default"][name]) throw new TypeError("Validozer does not recognize rule `".concat(name, "` in `").concat(attribute, "`"));
        return _validators["default"][name].exe({
          received: received,
          data: data,
          parameter: param && param.split('@')[0],
          parameter_value: value && value.split('@')[0]
        });
      });

      if (isInvalid || _validators["default"][catch_name].allowMessageEvenValid) {
        var messageFromstack = _messages["default"][catch_name] || _validators["default"][catch_name].message || "The :attribute is ".concat(catch_name);
        var message;

        if (messageFromstack.toString() === '[object Object]') {
          if (!Array.isArray(received) && !isNaN(received)) {
            messageFromstack = messageFromstack.numeric;
          } else if (typeof received === 'string') {
            messageFromstack = messageFromstack.string;
          } else if (Array.isArray(received)) {
            messageFromstack = messageFromstack.array;
          } else {
            messageFromstack = messageFromstack.file;
          }
        }

        message = messageFromstack && messageFromstack.replace(':attribute', attribute);

        if (catch_param) {
          if (catch_param.includes('@')) {
            var _catch_param$split = catch_param.split('@'),
                _catch_param$split2 = _slicedToArray(_catch_param$split, 2),
                alias = _catch_param$split2[1];

            catch_param = alias;
          }

          message = message && message.replace(":".concat(catch_name), (catch_param || '').replace(/,/g, ', '));
        }

        if (catch_value) {
          if (catch_value.includes('@')) {
            var _catch_value$split = catch_value.split('@'),
                _catch_value$split2 = _slicedToArray(_catch_value$split, 2),
                _alias = _catch_value$split2[1];

            catch_value = _alias;
          }

          message = message && message.replace(':value', catch_value);
        }

        return {
          isInvalid: isInvalid,
          message: message,
          failedIn: isInvalid ? catch_name : null
        };
      }

      return {
        isInvalid: isInvalid,
        failedIn: null
      };
    }
  }, {
    key: "make",
    value: function make(data, rules) {
      var instance = new Validozer();
      instance.data = data;
      instance.rules = rules;
      return instance;
    }
  }]);

  return Validozer;
}();

exports["default"] = Validozer;